import { Directive, input, signal } from '@angular/core';

@Directive({
  selector: '[classOnScroll]',
  standalone: false,
  host:{
    '(window:scroll)': 'onWindowScoll()',
    '[class]': 'className()'
  }
})
export class ClassOnScroll {
  readonly classOnScroll=input.required<string>();
  readonly className=signal<string>('transparent');

  onWindowScoll(){
    if(window.scrollY>100)
      this.className.set(this.classOnScroll());
    else
      this.className.set(null);
  }
}
